import { Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

function PersonalAccountCreationSuccess() {
    const { t } = useTranslation();
    const appName = useSelector((state: RootState) => state.auth.appName);

    const handleLoginClick = () => {
        const platform = localStorage.getItem("platform");
        if (platform === "exchange") {
            const exchange_url: any = process.env.REACT_APP_EXCHANGE_URL;
            window.location.replace(`${exchange_url}/login`);
            localStorage.setItem("platform", 'default');
        } else if (platform === "armdv") {
            const armdv_url: any = process.env.REACT_APP_ARMDV_LOGIN_URL;
            window.location.replace(`${armdv_url}`);
            localStorage.setItem("platform", 'default');
        } else {
            window.location.href = process.env.REACT_APP_ARMF_APP_URL as string;
        }
    };

    return (
        <>
            <Header />
            <Container fluid className="flex-grow-1 d-flex flex-column align-items-center justify-content-center py-5">
                <div className="text-center" style={{ maxWidth: 560, width: "100%" }}>
                    <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", position: "relative", width: 140, height: 140 }}>
                        <div style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "rgba(0, 208, 132, 0.12)" }} />
                        <div style={{ position: "absolute", inset: 12, borderRadius: "50%", background: "rgba(0, 208, 132, 0.18)" }} />
                        <i className="fa-solid fa-circle-check" style={{ fontSize: 80, color: "#00D084", position: "relative", zIndex: 1 }} />
                    </div>
                    <h3 className='mt-4 fst-italic' style={{ color: "#00D084" }}>{t('register.congrats')}</h3>
                    <p className='fw-normal mt-3'>
                        {t('register.success_body')} <span className='fw-bold fst-italic'>{t('register.success_welcome')}</span>
                    </p>
                    <p className='fw-bold text-secondary'>{t('register.success_verification')}</p>
                    <div className='d-grid gap-2 col-md-5 mx-auto mt-4'>
                        <Button className='btn btn-primary rounded-5' onClick={handleLoginClick}>
                            {t('register.login_btn')}
                        </Button>
                    </div>
                </div>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default PersonalAccountCreationSuccess;
